/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

/** Interface scale, kept per browser (a phone and a wall display want different sizes). */
export const UI_SCALES = [0.8, 0.9, 1, 1.1, 1.25, 1.5] as const;
const KEY = "nyrvex-ui-scale";

export function getUiScale(): number {
  try {
    const v = parseFloat(localStorage.getItem(KEY) ?? "");
    return UI_SCALES.includes(v as (typeof UI_SCALES)[number]) ? v : 1;
  } catch {
    return 1;
  }
}

export function applyUiScale(scale: number = getUiScale()): void {
  const root = document.documentElement;
  if (scale === 1) root.style.removeProperty("zoom");
  else root.style.zoom = String(scale);
}

export function setUiScale(scale: number): void {
  try {
    localStorage.setItem(KEY, String(scale));
  } catch {
    /* ignore */
  }
  applyUiScale(scale);
}
